<template>
  <div
    class="border rounded-sm p-4"
  >
    <div class="d-flex align-items-center" v-if="!maxConditions || maxConditions > 1">
      <span class="mb-3">Aplica en</span>
      <LmTreeSelect
        class="mx-3"
        style="max-width: 150px"
        :options="[{
          id: 'OR',
          name: 'al menos una'
        }, {
          id: 'AND',
          name: 'todas'
        }]"
        v-model="union.value"
      />
      <span class="mb-3">{{ union.value.id === 'OR' ? 'de ' : '' }}las condiciones</span>
    </div>
    <draggable
      v-if="nodes.length"
      :list="nodes"
      animation="150"
      handle=".handler"
    >
      <div
        v-for="(node, index) of nodes"
        :key="index"
      >
        <Group
          class="mb-2"
          v-if="'children' in node"
          :nodes="node.children"
          :union="node.union"
          :depth="depth + 1"
          :id="node.id"
          @node-add="onNodeAdd"
          @node-remove="onNodeRemove"
          @group-add="onGroupAdd"
          @group-remove="onGroupRemove"
          :noGroups="noGroups"
          :maxConditions="maxConditions"
          :conditionalsData="conditionalsData"
        />
        <Node
          v-else
          :node="node"
          :conditionalsData="conditionalsData"
          @node-remove="onNodeRemove({ nodes, id: node.id })"
        />
      </div>
    </draggable>
    <div
      class="d-flex"
      style="gap: 10px"
    >
      <NodeAddBtn
        :nodes="nodes"
        :maxConditions="maxConditions"
        @node-add="onNodeAdd"
      />
      <GroupAddBtn
        v-if="!noGroups"
        :nodes="nodes"
        @group-add="onGroupAdd"
      />
      <GroupRemoveBtn
        v-if="!noGroups"
        :nodes="nodes"
        :id="id"
        @group-remove="onGroupRemove"
      />
    </div>
  </div>
</template>

<script>
// Components
import Node from '@/components/lmConditionalBuilder/components/Node'
import NodeAddBtn from '@/components/lmConditionalBuilder/components/NodeAddBtn'
import GroupAddBtn from '@/components/lmConditionalBuilder/components/GroupAddBtn'
import GroupRemoveBtn from '@/components/lmConditionalBuilder/components/GroupRemoveBtn'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'

// Utils
import draggable from 'vuedraggable'
import { nanoid } from 'nanoid'

export default {
  name: 'Group',
  components: {
    Node,
    NodeAddBtn,
    GroupAddBtn,
    GroupRemoveBtn,
    draggable,
    LmTreeSelect
  },
  props: {
    nodes: Array,
    union: Object,
    // Permite grupos
    noGroups: Boolean,
    // Máximo de condiciones por grupo
    maxConditions: Number,
    depth: {
      type: Number,
      default: 0
    },
    id: {
      type: [Number, String],
      default: nanoid(5)
    },
    conditionalsData: Object
  },
  methods: {
    onNodeAdd (nodes) {
      this.$emit('node-add', nodes)
    },
    onNodeRemove (nodes) {
      this.$emit('node-remove', nodes)
    },
    onGroupAdd (nodes) {
      this.$emit('group-add', nodes)
    },
    onGroupRemove (nodes) {
      this.$emit('group-remove', nodes)
    }
  }
}
</script>
